import HundredBricksAPIError from '../../../HundredBricksAPIError';
class CalculateQuoterBricksError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('CalculateQuoterBricksError', ...args);
    }
}
export default CalculateQuoterBricksError;
